import env from "Consts/env";
import { apiSlice } from "../api/apiSlice";

export const bannerApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getDataBanner: builder.query({
			query: (args) => ({
				url: `/api/fds-banner/?placement=${args.placement}`,
				headers: {
					...env.HEADERS,
				},
				params: {
					...args.params,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300),
			}),

		}),
	}),
});

export const { useGetDataBannerQuery } = bannerApiSlice;
